import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { useTheme } from '@/contexts/ThemeContext';

type Mode = 'onboarding' | 'normal';

export default function GymJoinedCheckpoint() {
  const router = useRouter();
  const params = useLocalSearchParams<{
    gymName?: string | string[];
    gymId?: string | string[];
    mode?: string | string[];
  }>();
  const { theme } = useTheme();

  const gymNameParam = Array.isArray(params?.gymName) ? params.gymName[0] : params?.gymName;
  const gymName = gymNameParam || 'your gym';
  const modeParam = Array.isArray(params?.mode) ? params.mode[0] : params?.mode;
  const mode: Mode = modeParam === 'normal' ? 'normal' : 'onboarding';

  const handlePrimary = () => {
    if (mode === 'onboarding') {
      router.replace('/gate');
    } else {
      router.replace('/(tabs)');
    }
  };

  return (
    <View style={[styles.container, { backgroundColor: theme.colors.background }]}>
      <View style={styles.content}>
        <Text style={[styles.title, { color: theme.colors.text }]}>Gym joined</Text>
        <Text style={[styles.body, { color: theme.colors.textSecondary }]}>
          You’re now part of {gymName} on DUEL.
        </Text>
        <Text style={[styles.body, { color: theme.colors.textSecondary }]}>
          Your workouts will count toward gym leaderboards and challenges.
        </Text>

        <TouchableOpacity
          style={[styles.primaryButton, { backgroundColor: theme.colors.accent }]}
          onPress={handlePrimary}>
          <Text style={[styles.primaryButtonText, { color: theme.colors.accentForeground }]}>
            {mode === 'onboarding' ? 'Continue' : 'Back to App'}
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[styles.secondaryButton, { borderColor: theme.colors.border }]}
          onPress={() => router.replace('/gym/leaderboard')}>
          <Text style={[styles.secondaryButtonText, { color: theme.colors.textSecondary }]}>
            View Gym Leaderboard
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.linkButton}
          onPress={() => router.replace('/(profile)/home-gym')}>
          <Text style={[styles.linkText, { color: theme.colors.textSecondary }]}>
            Change gym
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: 'center', alignItems: 'center', padding: 24 },
  content: { width: '100%', gap: 20 },
  title: { fontSize: 28, fontWeight: '900' },
  body: { fontSize: 16, lineHeight: 22 },
  primaryButton: { paddingVertical: 14, borderRadius: 0, alignItems: 'center' },
  primaryButtonText: { fontSize: 16, fontWeight: '700' },
  secondaryButton: {
    paddingVertical: 12,
    borderRadius: 0,
    alignItems: 'center',
    borderWidth: 1,
  },
  secondaryButtonText: { fontSize: 15, fontWeight: '600' },
  linkButton: { alignItems: 'center' },
  linkText: { fontSize: 14, fontWeight: '600', textDecorationLine: 'underline' },
});
